import React from 'react';
import { LoaderCircle } from 'lucide-react'
import PricingCalculatorForm from './form'
import PricingCalculatorSummary from './summary'

class PricingCalculator extends React.Component {

  render() {
    if (this.props.pricing_calculator === null) {
      return (
        <div className='text-center'><p><LoaderCircle className="inline-block size-8 animate-spin"/></p></div>
      )
    }

    return (
      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <PricingCalculatorForm
            pricing_calculator={this.props.pricing_calculator}
            lesson_order={this.props.lesson_order}
            onUpdate={this.props.onUpdate}
          />
        </div>
        <PricingCalculatorSummary
          pricing_calculator={this.props.pricing_calculator}
          lesson_order={this.props.lesson_order}
          change_applied={this.props.change_applied}
          onSaveLessonOrder={this.props.onSaveLessonOrder}
          onAddToOrder={this.props.onAddToOrder}
          onUpdateOrder={this.props.onUpdateOrder}
          onPlaceOrder={this.props.onPlaceOrder}
        />
      </div>
    );
  }
}

export default PricingCalculator